module.exports = __webpack_public_path__ + "img/red-arrow-up.8c34afd8.svg";